import Cookies from 'js-cookie';
import 'clientjs';

const fingerprintKey = 'fingerprint';
const domain = 'orangecountyscu.org';
const maxAgeInDays = 365;

const generateFingerprint = () => {
  // https://github.com/jackspirou/clientjs/issues/75
  const client = new ClientJS(); // eslint-disable-line no-undef
  return client.getFingerprint();
};

// todo: extract fingerprint logic out
const getFingerprint = () => {
  let fingerprint = readFromStore(fingerprintKey);
  if (fingerprint === undefined) {
    fingerprint = generateFingerprint();
    console.log('generateFingerprint', fingerprint);
    writToStore(fingerprintKey, fingerprint);
  }
  return fingerprint;
};

const readFromStore = (key) => {
  return Cookies.get(key);
};

const writToStore = (key, val) => {
  console.log('writToStore', key, val);
  Cookies.set(key, val, { domain, expires: maxAgeInDays });
};

export { getFingerprint, readFromStore, writToStore };
